import PosStore from '../../../stores/PosStore';

import PosProfile from './PosProfile.react';
import PosMenu from './PosMenu.react';
import PosNotes from './PosNotes.react';
import PreOrder from './PreOrder.react';
import Discount from './Discount.react';
import FeeDonation from './feesDonations/FeeDonation.react';

class PosSidebar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
		    sidebarPage          : PosStore.getState().sidebarPage,
		    showSidebar          : false
        };

        this.onPosStoreChange = this.onPosStoreChange.bind(this);
    }

    componentDidMount() {
    	if (PosStore.getState().sidebarPage)
    		this.open();

        PosStore.addChangeListener(this.onPosStoreChange);
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
    }

    onPosStoreChange() {
        var pos = PosStore.getState();

        this.setState({
            sidebarPage : pos.sidebarPage
        }, () => {
            $('.pos-sidebar').css({
                'left' : (!pos.showSidebar ? -300 : 0)
            });

            $('.pos-main').css({
                'left' : (!pos.showSidebar ? 0 : 300),
                'width' : (!pos.showSidebar ? '100%' : 'calc(100% - 300px)')
            });
        });
    }

    open() {
        var pos = PosStore.getState();

        $('.pos-sidebar').css({
            'left' : (!pos.showSidebar ? -300 : 0)
        });

        $('.pos-main').css({
            'left' : (!pos.showSidebar ? 0 : 300),
            'width' : (!pos.showSidebar ? '100%' : 'calc(100% - 300px)')
        });
    }

    render() {
        var guest       = this.props.guest;
        var cart        = this.props.cart;
    	var sidebarPage = this.state.sidebarPage;
        var preOrders   = this.props.preOrders;
        var appliedLoyaltyPoints = this.props.appliedLoyaltyPoints;
        var appliedDiscounts     = this.props.appliedDiscounts;
        var allotment            = this.props.allotment;
        var appliedFeesDonations = this.props.appliedFeesDonations;
        
        return (
        	<div className='pos-sidebar'>
                { sidebarPage === 'profile' &&
        	        <PosProfile
                        guest={guest} />
                }

                { sidebarPage === 'menu' &&
                    <PosMenu
                        guest={guest}
                        cart={cart}
                        setPage={(page) => { this.props.setPage(page); }} />
                }

                { sidebarPage === 'notes' &&
                    <PosNotes
                        guest={guest} />
                }

                { sidebarPage === 'pre-order' &&
                    <PreOrder
                        guest={guest}
                        preOrders={preOrders}
                        onSearch={(page, query) => { this.props.onSearch(page, query); }} />
                }

                { sidebarPage === 'discounts' &&
                    <Discount
                        guest={guest}
                        preOrders={preOrders}
                        appliedLoyaltyPoints={appliedLoyaltyPoints}
                        appliedDiscounts={appliedDiscounts}
                        allotment={allotment}
                        cart={cart} />
                }

                { sidebarPage === 'fees-donations' &&
                    <FeeDonation
                        guest={guest}
                        appliedFeesDonations={appliedFeesDonations} />
                }
        	</div>
        );
    }
}

export default PosSidebar;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/PosSidebar.react.jsx